import React, { useEffect, useState } from 'react';

import SelectorChip from 'components/DesignSystem/SelectorChip';
import About from 'components/Meteorology/Weather/Area/About';
import Status from 'components/Meteorology/Weather/Area/Status';
import References from 'components/Meteorology/Weather/Area/References';
import History from 'components/Meteorology/Weather/Area/History';
import useDragScroll from 'utils/hooks/useDragScroll';

import './index.scss';

export default function AreaMobile({
  areaAcronym,
  areaLabel,
}: {
  areaAcronym: string,
  areaLabel: string,
}) {
  const [key, setKey] = useState('about');
  const {
    ref,
    dragHandlers: {
      onPointerDown, onPointerMove, onPointerUp, onPointerLeave, onClickCapture,
    },
  } = useDragScroll<HTMLDivElement>();

  const showHistory = areaAcronym !== 'tropicos';
  const statusTitle = areaAcronym === 'mjo' ? 'Diagrama de Fases / Previsão' : 'Observado / Previsão';

  useEffect(() => {
    if (!showHistory && key === 'history') setKey('about');
  }, [showHistory, key]);

  const tabs = [
    { key: 'about', label: 'Sobre' },
    { key: 'status', label: statusTitle },
    { key: 'references', label: 'Impactos / Referências' },
    ...(showHistory ? [{ key: 'history', label: 'Histórico' }] : []),
  ];

  return (
    <div className="area-mobile">
      <div className="area-mobile-tabs">
        <div
          className="area-mobile-tabs-scroller"
          ref={ref}
          onPointerDown={onPointerDown}
          onPointerMove={onPointerMove}
          onPointerUp={onPointerUp}
          onPointerLeave={onPointerLeave}
          onClickCapture={onClickCapture}
        >
          {tabs.map((tab) => (
            <SelectorChip
              key={tab.key}
              shape="round"
              role="tab"
              selected={key === tab.key}
              onClick={() => setKey(tab.key)}
            >
              {tab.label}
            </SelectorChip>
          ))}
        </div>
      </div>
      <div className="area-mobile-content">
        {key === 'about' && <About areaAcronym={areaAcronym} areaLabel={areaLabel} />}
        {key === 'status' && <Status area={areaAcronym} />}
        {key === 'references' && <References areaAcronym={areaAcronym} areaLabel={areaLabel} />}
        {key === 'history' && showHistory && (
          <History areaAcronym={areaAcronym} areaLabel={areaLabel} />
        )}
      </div>
    </div>
  );
}
